/** Adresse als Zeilen — für Versand- und Rechnungsadresse identisch. */
const AddressLines = ({ address }) => (
  <>
    {address.company && <span className="block">{address.company}</span>}
    <span className="block">
      {address.firstName} {address.lastName}
    </span>
    <span className="block">{address.address}</span>
    <span className="block">
      {address.zip} {address.city}
    </span>
    {address.country && <span className="block">{address.country}</span>}
    {address.phone && <span className="block">{address.phone}</span>}
  </>
);

export default AddressLines;
